import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export function Pagination({ currentPage, totalCount, pageSize, onPageChange }) {
  const totalPages = Math.ceil(totalCount / pageSize);
  if (totalPages <= 1) return null;

  const pages = [];
  const maxVisible = 5;
  let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
  let end = Math.min(totalPages, start + maxVisible - 1);
  if (end - start < maxVisible - 1) start = Math.max(1, end - maxVisible + 1);

  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <div className="flex items-center justify-between border-t border-slate-200 pt-3 mt-3" data-testid="pagination">
      <p className="text-xs text-slate-500">
        Showing {Math.min((currentPage - 1) * pageSize + 1, totalCount)}-{Math.min(currentPage * pageSize, totalCount)} of {totalCount}
      </p>
      <div className="flex items-center gap-1">
        <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage <= 1}
          className="px-2 py-1 rounded border border-slate-200 text-xs text-slate-600 hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed"
          data-testid="pagination-prev">
          <ChevronLeft size={14} />
        </button>
        {start > 1 && <button onClick={() => onPageChange(1)} className="px-2.5 py-1 rounded text-xs text-slate-600 hover:bg-slate-50">1</button>}
        {start > 2 && <span className="text-xs text-slate-400 px-1">...</span>}
        {pages.map(p => (
          <button key={p} onClick={() => onPageChange(p)} data-testid={`pagination-page-${p}`}
            className={`px-2.5 py-1 rounded text-xs font-medium ${p === currentPage ? 'bg-[#1B5486] text-white' : 'text-slate-600 hover:bg-slate-50'}`}>
            {p}
          </button>
        ))}
        {end < totalPages - 1 && <span className="text-xs text-slate-400 px-1">...</span>}
        {end < totalPages && <button onClick={() => onPageChange(totalPages)} className="px-2.5 py-1 rounded text-xs text-slate-600 hover:bg-slate-50">{totalPages}</button>}
        <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage >= totalPages}
          className="px-2 py-1 rounded border border-slate-200 text-xs text-slate-600 hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed"
          data-testid="pagination-next">
          <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
}
